import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_BusTrackerBusMaintenance } from "../shared/data.service";
import { RouteModifyComponent } from "./route-modify/route-modify.component";

@Component({
	selector: "caass-bus-maintenance-route-table",
	templateUrl: "./bus-maintenance-route-table.component.html",
	styleUrls: ["./bus-maintenance-route-table.component.css"],
})
export class BusMaintenanceRouteTableComponent implements OnInit {
	constructor(
		private RouteService: DataService_BusTrackerBusMaintenance,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadBusRoute();
	}

	ngOnChanges() {
		this.SelectedBusRoute = null;

		this.loadBusRoute();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedBus: any;
	@Output() SelectedRouteChanged: EventEmitter<any> = new EventEmitter();

	Processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedBusRoute: any;
	lstBusRoute: any = [];

	//Filter lists
	lstBusRouteTypeDesc: any = [];
	lstActiveDesc: any = [];
	lstDefinedByDesc: any = [];
	lstisAllowGuestRiderDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'BusRouteNbr', header: 'Number' },
		// { field: 'BusRouteDesc', header: 'Description' },
		{ field: "BusRouteTypeDesc", header: "Type" },
		{ field: "StudentCount", header: "Total Students" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadBusRoute() {
		this.errorMessage = "";

		if (this.SelectedBus == undefined) {
			this.lstBusRoute = [];
			this.SelectedBusRoute = null;
			return;
		}

		this.loading = true;

		var result = this.RouteService.RouteMaintenanceTableSelectList(this.SelectedBus.BusID);
		result.subscribe(
			(response) => {
				this.lstBusRoute = response;

				//Load Data Filter Lists
				this.lstBusRouteTypeDesc = Array.from(new Set(this.lstBusRoute.map((item: any) => item.BusRouteTypeDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstBusRoute.map((item: any) => item.ActiveDesc))).sort();
				this.lstDefinedByDesc = Array.from(new Set(this.lstBusRoute.map((item: any) => item.DefinedByDesc))).sort();
				this.lstisAllowGuestRiderDesc = Array.from(new Set(this.lstBusRoute.map((item: any) => item.isAllowGuestRiderDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadBusRoute();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(RouteModifyComponent, {
			header: "Add Route",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				EditMode: false,
				Imported: false,
				SelectedBus: this.SelectedBus,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadBusRoute();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.CanEdit() == false) {
			return;
		}

		if (this.SelectedBus == undefined) {
			this.errorMessage = "Select a route to edit";
			return;
		}

		var ref = this.dialogService.open(RouteModifyComponent, {
			header: "Edit Route",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				EditMode: true,
				Imported: this.SelectedBus.DefinedByID <= 2 ? true : false,
				SelectedBus: this.SelectedBus,
				BusRouteID: this.SelectedBusRoute.BusRouteID,
				BusRouteTypeID: this.SelectedBusRoute.BusRouteTypeID,
				BusRouteNbr: this.SelectedBusRoute.BusRouteNbr,
				BusRouteDesc: this.SelectedBusRoute.BusRouteDesc,
				BusRouteMisc1: this.SelectedBusRoute.BusRouteMisc1,
				BusRouteMisc2: this.SelectedBusRoute.BusRouteMisc2,
				DefinedByID: this.SelectedBusRoute.DefinedByID,
				isAllowGuestRider: this.SelectedBusRoute.isAllowGuestRider,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadBusRoute();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedBus == undefined) {
			this.errorMessage = "Select a route to toggle";
			return;
		}

		//Call SP
		this.Processing = true;

		var changeTo = this.SelectedBusRoute.Active == true ? 0 : 1;

		var result = this.RouteService.BusRouteToggle(this.SelectedBusRoute.BusRouteID, changeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadBusRoute();
				} else {
					var MSG = "";

					if (changeTo == 1) {
						MSG = "Could not activate the route";
					} else {
						MSG = "Could not deactivate the route";
					}

					//
					// Error message
					//
					this.confirmationService.confirm({
						key: "route",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedBus == undefined) {
			this.errorMessage = "Select a route to delete";
			return;
		}

		//
		// Check if the alert type is in use
		//
		this.RouteInUse();
	}

	RouteInUse() {
		this.Processing = true;

		var result = this.RouteService.BusRouteInUse(this.SelectedBusRoute.BusRouteID);
		result.subscribe(
			(response) => {
				if (response) {
					this.confirmationService.confirm({
						key: "route",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Route already in use. Remove Students assigned to this route before deleting it.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				} else {
					this.ConfirmDelete();
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	ConfirmDelete() {
		this.confirmationService.confirm({
			key: "confirmroutedelete",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete this route?",
			header: "Confirm Delete Route",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
			reject: () => {
				this.Processing = false;
			},
		});
	}

	FinishDelete() {
		var result = this.RouteService.BusRouteDelete(this.SelectedBusRoute.BusRouteID);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadBusRoute();
				} else {
					this.confirmationService.confirm({
						key: "route",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not delete the Route.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedBusRoute = val.data;

		this.SelectedRouteChanged.emit(this.SelectedBusRoute);
	}
	onRowUnselect(val) {
		this.SelectedBusRoute = null;

		this.SelectedRouteChanged.emit(this.SelectedBusRoute);
	}
	onRowDblClick(BusRoute) {
		this.SelectedBusRoute = BusRoute;

		this.SelectedRouteChanged.emit(this.SelectedBusRoute);

		this.onEdit();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	CanAdd() {
		return this.SelectedBus == undefined ? false : true;
	}

	CanEdit() {
		return this.SelectedBus == undefined || this.SelectedBusRoute == undefined ? false : true;
	}

	CanDelete() {
		if (this.SelectedBus == undefined || this.SelectedBusRoute == undefined) {
			return false;
		}
		if (this.SelectedBusRoute.DefinedByID <= 2) {
			return false;
		}

		return true;
	}

	////////////////////////////////////////////
}
